import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const contactGroupRoutes: RouteRecordRaw[] = [
  {
    path: '/contact-groups',
    name: 'contact-groups',
    component: () => import('@/modules/contact-groups/views/ContactGroupListView.vue'),
    meta: {
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
